export default __webpack_public_path__ + "968c2b2812c66277d332fc90b4ba24f4.png";